import { createApiCall } from 'lib/base';
import { generateEndpoint } from 'utils/urlHelpers';

const FETCH_INVESTCORE_USER_REQUIRE_RESYNC_ECONTRACT_LINK_API_ID =
  'DASHBOARD/FETCH_INVESTCORE_USER_REQUIRE_RESYNC_ECONTRACT_LINK_API';

const apiCall = createApiCall(
  FETCH_INVESTCORE_USER_REQUIRE_RESYNC_ECONTRACT_LINK_API_ID,
  params => ({
    endpoint: generateEndpoint({
      host: `/api/admin/users/required-resync-econtract-link`,
      params,
    }),
    method: 'GET',
  })
);

export default apiCall;
